import { Box, Typography } from "@mui/material";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { HAS_LOWERCASE, HAS_NUMBERS, HAS_SPECIAL_CHARACTERS, HAS_UPPERCASE, HAS_WHITESPACE } from "@utils/expreciones";

interface Props {
  password: string;
}

/**
 * Reglas de la contraseña nueva, en verde las que ya se cumplen y en rojo las que faltan. Mismas
 * reglas que la pantalla legacy de nueva contraseña; mismo estilo que el `RuleRow` de `CrearCuenta`.
 */
export const ListPasswordRules = ({ password }: Props) => {
  const rules = [
    { label: "Entre 8 y 20 caracteres", ok: password.length >= 8 && password.length <= 20 },
    { label: "Un carácter numérico", ok: HAS_NUMBERS.test(password) },
    { label: "Un carácter especial", ok: HAS_SPECIAL_CHARACTERS.test(password) },
    { label: "Una mayúscula", ok: HAS_UPPERCASE.test(password) },
    { label: "Una minúscula", ok: HAS_LOWERCASE.test(password) },
    { label: "Sin espacios en blanco", ok: !HAS_WHITESPACE.test(password) },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
      <Typography variant="body2" fontWeight={500} color="text.primary">
        Tu contraseña debe contener:
      </Typography>
      {rules.map((rule) => (
        <Box key={rule.label} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          {rule.ok ? (
            <CheckCircle sx={{ fontSize: 15, color: "success.main" }} />
          ) : (
            <Cancel sx={{ fontSize: 15, color: "error.main" }} />
          )}
          <Typography variant="body2" sx={{ color: rule.ok ? "success.main" : "error.main" }}>
            {rule.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
